import AuthLogList from 'common/pages/auth-log/AuthLogList.tsx'

export const AuthLogListAdmin = () => <AuthLogList />